export default function generateTimeStringFromMinutes(minutes) {
  const days = Math.floor(minutes / (24 * 60));
  minutes -= days * 24 * 60;

  const hours = Math.floor(minutes / 60);
  minutes -= hours * 60;

  return `${days}d ${hours}h ${minutes}m`;
}
